import { Worksheet } from "exceljs";
import { TakeOffStore } from "modules/takeOff/TakeOffStore";
import {
  borderExpressionStyle,
  borderThinStyle,
  fillDarkGray,
  fillLightGray,
  fontNormal,
  fontToDarkFill,
} from "./ReportStyles";

const getDataTakeoff = (worksheet: Worksheet) => {
  worksheet = setColumnHeader(worksheet);

  let formatedData: any = [];

  for (let i = 0; i < TakeOffStore.takeOffFilteredItems.length; i++) {
    const element = TakeOffStore.takeOffFilteredItems[i];
    let isNumber = false;
    for (let j = 0; j < TakeOffStore.takeOffColumns.length; j++) {
      let column = element.properties[TakeOffStore.takeOffColumns[j]];
      isNumber = false;
      if (column && !isNaN(Number((column.value + "").replace(",", ".")))) {
        column.value = Number((column.value + "").replace(",", "."));
        isNumber = true;
      }

      let columnValue = isNumber
        ? Number(column.value.toFixed(2))
        : column && column.value
        ? column.value
        : "";
      formatedData.push({
        [j + "-" + i]: columnValue,
        col: j,
        row: i,
        pos: j + "-" + i,
      });
    }
  }

  for (let i = 0; i < formatedData.length; i++) {
    worksheet.getCell(
      toColumnName(formatedData[i]["col"] + 1) + (formatedData[i]["row"] + 13)
    ).value = formatedData[i][formatedData[i]["pos"]];

    worksheet.getCell(
      toColumnName(formatedData[i]["col"] + 1) + (formatedData[i]["row"] + 13)
    ).font = fontNormal;
    worksheet.getCell(
      toColumnName(formatedData[i]["col"] + 1) + (formatedData[i]["row"] + 13)
    ).border = borderThinStyle;
    worksheet.getCell(
      toColumnName(formatedData[i]["col"] + 1) + (formatedData[i]["row"] + 13)
    ).fill = fillLightGray;
    worksheet.getCell(
      toColumnName(formatedData[i]["col"] + 1) + (formatedData[i]["row"] + 13)
    ).alignment = { vertical: "middle" };
  }

  return worksheet;
};

const setColumnHeader = (worksheet: Worksheet) => {
  for (let j = 0; j < TakeOffStore.takeOffColumns.length; j++) {
    if (j >= 11) {
      worksheet.getCell(toColumnName(j + 1) + "12").fill = fillDarkGray;
      worksheet.getCell(toColumnName(j + 1) + "12").alignment = {
        vertical: "middle",
      };
      worksheet.getCell(toColumnName(j + 1) + "12").font = fontToDarkFill;
      worksheet.getColumn(j + 1).width = 12.01 * 1.24;
    }
    worksheet.getCell(toColumnName(j + 1) + "12").value =
      TakeOffStore.takeOffColumns[j];
  }

  if (TakeOffStore.takeOffColumns.length >= 11) {
    worksheet.addConditionalFormatting({
      ref: "L1:" + toColumnName(TakeOffStore.takeOffColumns.length) + "12",
      rules: borderExpressionStyle,
    });
  }

  return worksheet;
};

const toColumnName = (num: number) => {
  for (var ret = "", a = 1, b = 26; (num -= a) >= 0; a = b, b *= 26) {
    ret = String.fromCharCode(parseInt(((num % b) / a).toString()) + 65) + ret;
  }
  return ret;
};

export default getDataTakeoff;



// WEBPACK FOOTER //
// ./src/modules/costPlan/assets/excelReports/takeoffCustom.ts